import React, { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import urlApi from "shared/actions/urlApi";
import {
  ArtzIcon,
  DeziiignIcon,
  GalllleryArtIcon,
  GalllleryIcon,
  HseDesignLinkIcon,
  HseSpaceIcon,
  LpuIcon,
  MediiiaIcon,
  MyMediiiaIcon,
  PrintArtzIcon,
  GreenAwardIcon,
} from 'shared/icons/ArtzIcon';
import { AppTester } from "../../supporting";
import { API, Designer, DesignerAPI, Endpoints } from "@brg/api";
import { getTextFromElement } from "../pages/designer/support/getTextElement";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useGetPersonalChannel } from "./api/useGetPersonalChannel";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";

type TD = {
  [key: string]: string | undefined
}

const DOMAIN_NAMES: TD = {
  'gallllery.profile': process.env.REACT_APP_URL_GALLERY,
  'gallllery.collection': process.env.REACT_APP_URL_GALLERY,
  'shop.profile': process.env.REACT_APP_URL_ARTZ_SHOP,
  'shop.collection': process.env.REACT_APP_URL_ARTZ_SHOP,
}

const ROLES_LINK = ['hse.space', 'lpudesign', 'hsedesign'];

export const getServiceLinks = (props: any) => {
  const {
    id,
    isDeziiignMain,
    isGalllleryArt,
    isGreenAward,
    isMediiia,
    handleMoveToLink,
    channel: channelId,
    hasArtMediiaProjects,
    galleryOrArtzServices,
    isArtMediiia,
  } = props
  let result = {};
  result = {
    // ...(!channelId) ? null : {
    //   myMediiia: {
    //     link: process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId,
    //     action: () => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId),
    //     isLinks: true,
    //     element: MyMediiiaIcon
    //   }
    // },
    ...(isDeziiignMain) ? null : {
      deziiign: {
        link: process.env.REACT_APP_URL_DEZIIIGN_RU + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_DEZIIIGN_RU + CreateLinkTo.designer(id)),
        isLinks: true,
        element: DeziiignIcon
      }
    },
    ...(isGalllleryArt) ? null : {
      arts: {
        link: process.env.REACT_APP_URL_ARTZ + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_ARTZ + CreateLinkTo.designer(id)),
        isLinks: true,
        element: ArtzIcon,
        hidden: isGalllleryArt
      }
    },
    ...(isMediiia) ? null : {
      mediiia: {
        link: process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.designer(id)),
        isLinks: true,
        element: () => MediiiaIcon({ prefix: '' })
      }
    },
    ...(!hasArtMediiaProjects || isArtMediiia) ? null : {
      artMediiia: {
        link: process.env.REACT_APP_URL_MEDIIIA_COM + '/art' + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/art' + CreateLinkTo.designer(id)),
        isLinks: true,
        element: () => MediiiaIcon({ prefix: 'art.' })
      }
    },
    ...(isGreenAward) ? null : {
      greenaward: {
        link: 'https://green-award.ru' + CreateLinkTo.designer(id),
        action: () => window.open('https://green-award.ru' + CreateLinkTo.designer(id)),
        isLinks: true,
        element: GreenAwardIcon
      }
    },
  };

  galleryOrArtzServices.forEach((service: string) => {
    const key = service?.indexOf('gallllery') !== -1 ? 'gallery' : 'artz'

    result[key as any] = {
      action: () => handleMoveToLink(service),
      isLinks: true,
      element: key === 'gallery' ? GalllleryIcon : PrintArtzIcon
    }
  })

  return result
}

export interface LinksItems {
  action: () => void;
  isLinks: boolean;
  element: (() => ReactNode) | ReactNode
}

export const useServiceLinks = (id: string, designer?: Designer) => {

  const {
    isMediiia,
    isArtMediiia,
    isDeziiignMain,
    isGalllleryArt,
    isGreenAward,
    isFr,
    isKz,
  } = useAppTester();

  const designerRef = useRef<any>(null);
  const [serviceLinksList, setServiceLinksList] = useState<string[]>([]);
  const { data: channelsInfo } = useGetPersonalChannel(id, true);

  const channel = useMemo(() => {
    if (channelsInfo?.personalChannels?.length === 1) {
      return channelsInfo?.personalChannels?.[0]?.teamId;
    }
    else if (!!channelsInfo?.defaultChannel) {
      return channelsInfo?.defaultChannel;
    }
    else if (channelsInfo?.autoChannel) {
      return channelsInfo?.autoChannel?.teamId;
    }

    return null
  }, [channelsInfo])

  const roleLink = useMemo(() => {

    if (!isDeziiignMain) return null;

    const isEmployee =
      designerRef.current?.globalTypes?.includes("Employee") === true

    const isCooperator =
      designerRef.current?.globalTypes?.includes("Cooperator") === true

    const isStudent =
      designerRef.current?.globalTypes?.includes("Student") === true &&
      !isCooperator &&
      !isEmployee

    const isLPUEmployee =
      designerRef.current?.globalTypes?.includes("lpuemployee") === true

    const isIfCIDStudent =
      !!designerRef.current?.globalTypes?.includes("Hsecreativestudent")

    if (!!isLPUEmployee) {
      return {
        lpudesign: {
          action: () => window.open(process.env.REACT_APP_URL_HSECREATIVE + CreateLinkTo.designer(id)),
          isLinks: true,
          element: LpuIcon,
        }
      }
    }
    if (!!isIfCIDStudent) {
      return {
        irki: {
          action: () => window.open(process.env.REACT_APP_URL_HSE_SPACE + CreateLinkTo.designer(id)),
          isLinks: true,
          element: HseSpaceIcon,
        }
      }
    }
    if (isStudent || isEmployee || isCooperator) {
      return {
        hsedesign: {
          action: () => window.open(process.env.REACT_APP_URL_HSEDESIGN_RU + CreateLinkTo.designer(id)),
          isLinks: true,
          element: HseDesignLinkIcon,
        }
      }
    }

    return null;
  }, [designerRef.current, isDeziiignMain])

  useEffect(() => {
    if (id) {
      API.request()
        .endpoint(Endpoints.gateway)
        .url("/account/api/Account/GetActiveServices")
        .addQuery('accountId', id)
        .get()
        .send()
        .then((r) => r.json())
        .then((response) => {
          DesignerAPI.Get({ idDesigner: id })
            .then((r) => r.json())
            .then((responseSecond) => {
              designerRef.current = responseSecond
              return setServiceLinksList(response)
            })
        });
    }
  }, [id])

  const getActiveCardPath = (service: string) => {
    switch (service) {
      case 'gallllery.collection':
        return '/collection/'
      case 'gallllery.profile':
        return '/publicprofile/'
      case 'shop.collection':
        return '/collection/museum/'
      case 'shop.profile':
        return '/profile/museum/'
      default:
        return '/collection/'
    }
  }

  const handleMoveToLink = useCallback((service: string) => {
    const psfx = `shouldLogin=false`;

    const computeService = ['gallllery.collection', 'gallllery.profile']?.includes(service) ? 'gallery' :
      ['shop.profile', 'shop.collection']?.includes(service) ? 'artz' : service

    urlApi()?.getCollectionsByUser(id, computeService)
      .then((r) => {
        if (!r) return false;

        const domain = DOMAIN_NAMES[service as keyof TD]
        const route = getActiveCardPath(service)
        const userId = id
        const cardId = !r?.cardId ? '' : `card=${r?.cardId ?? 'empty'}&${psfx}`

        setTimeout(() => { window.open(domain + route + userId + cardId) })

      })

  }, [id])

  const hasArtMediiaProjects = useMemo(() => {
    return serviceLinksList?.includes('art.mediiia')
  }, [serviceLinksList])

  const galleryOrArtzServices = useMemo(() => {
    let result = [];

    if (serviceLinksList?.includes('gallllery.collection')) {
      result.push('gallllery.collection')
    }
    if (serviceLinksList?.includes('gallllery.profile')) {
      result.push('gallllery.profile')
    }
    if (serviceLinksList?.includes('shop.profile')) {
      result.push('shop.profile')
    }
    if (serviceLinksList?.includes('shop.collection')) {
      result.push('shop.collection')
    }

    return result
  }, [serviceLinksList])

  const links = useMemo(() => {
    if (isFr || isKz) {
      return {};
    }
    return {
      ...getServiceLinks({
        id,
        isDeziiignMain,
        isGalllleryArt,
        isGreenAward,
        isMediiia,
        handleMoveToLink,
        channel,
        hasArtMediiaProjects,
        galleryOrArtzServices,
        isArtMediiia
      }), ...roleLink
    }
  }, [handleMoveToLink, isDeziiignMain, isGalllleryArt, isMediiia, isGreenAward, roleLink, channel, galleryOrArtzServices, hasArtMediiaProjects, isArtMediiia])

  const filteredLinks = useMemo(() => {
    return Object.fromEntries(
      Object.entries(links)
        .filter(([key, value]) => {


          // @ts-ignore
          const renderedElement = typeof value.element === 'function' ? value.element() : null;
          const textFromElement = getTextFromElement(renderedElement);

          if (['artz', 'gallllery']?.includes(textFromElement) && !!galleryOrArtzServices?.length) {
            return true
          }

          return serviceLinksList?.includes(textFromElement) ||
            (serviceLinksList?.includes("greenaward") && textFromElement === "Зеленая премия") ||
            ROLES_LINK?.includes(textFromElement) || (!!channel && key === 'myMediiia')
        })
    );
  }, [links, serviceLinksList, channel, galleryOrArtzServices])

  return filteredLinks
}import React, { ReactNode, useCallback, useEffect, useMemo, useRef, useState } from "react";
import urlApi from "shared/actions/urlApi";
import {
  ArtzIcon,
  DeziiignIcon,
  GalllleryArtIcon,
  GalllleryIcon,
  HseDesignLinkIcon,
  HseSpaceIcon,
  LpuIcon,
  MediiiaIcon,
  MyMediiiaIcon,
  PrintArtzIcon,
  GreenAwardIcon,
} from 'shared/icons/ArtzIcon';
import { AppTester } from "../../supporting";
import { API, Designer, DesignerAPI, Endpoints } from "@brg/api";
import { getTextFromElement } from "../pages/designer/support/getTextElement";
import { CreateLinkTo } from "shared/constants/linkTo";
import { useGetPersonalChannel } from "./api/useGetPersonalChannel";
import useAppTester from "shared/MobileMenu/hooks/useAppTester";

type TD = {
  [key: string]: string | undefined
}

const DOMAIN_NAMES: TD = {
  'gallllery.profile': process.env.REACT_APP_URL_GALLERY,
  'gallllery.collection': process.env.REACT_APP_URL_GALLERY,
  'shop.profile': process.env.REACT_APP_URL_ARTZ_SHOP,
  'shop.collection': process.env.REACT_APP_URL_ARTZ_SHOP,
}

const ROLES_LINK = ['hse.space', 'lpudesign', 'hsedesign'];

export const getServiceLinks = (props: any) => {
  const {
    id,
    isDeziiignMain,
    isGalllleryArt,
    isGreenAward,
    isMediiia,
    handleMoveToLink,
    channel: channelId,
    hasArtMediiaProjects,
    galleryOrArtzServices,
    isArtMediiia,
  } = props
  let result = {};
  result = {
    // ...(!channelId) ? null : {
    //   myMediiia: {
    //     link: process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId,
    //     action: () => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/teams/' + channelId),
    //     isLinks: true,
    //     element: MyMediiiaIcon
    //   }
    // },
    ...(isDeziiignMain) ? null : {
      deziiign: {
        link: process.env.REACT_APP_URL_DEZIIIGN_RU + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_DEZIIIGN_RU + CreateLinkTo.designer(id)),
        isLinks: true,
        element: DeziiignIcon
      }
    },
    ...(isGalllleryArt) ? null : {
      arts: {
        link: process.env.REACT_APP_URL_ARTZ + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_ARTZ + CreateLinkTo.designer(id)),
        isLinks: true,
        element: ArtzIcon,
        hidden: isGalllleryArt
      }
    },
    ...(isMediiia) ? null : {
      mediiia: {
        link: process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + CreateLinkTo.designer(id)),
        isLinks: true,
        element: () => MediiiaIcon({ prefix: '' })
      }
    },
    ...(!hasArtMediiaProjects || isArtMediiia) ? null : {
      artMediiia: {
        link: process.env.REACT_APP_URL_MEDIIIA_COM + '/art' + CreateLinkTo.designer(id),
        action: () => window.open(process.env.REACT_APP_URL_MEDIIIA_COM + '/art' + CreateLinkTo.designer(id)),
        isLinks: true,
        element: () => MediiiaIcon({ prefix: 'art.' })
      }
    },
    ...(isGreenAward) ? null : {
      greenaward: {
        link: 'https://green-award.ru' + CreateLinkTo.designer(id),
        action: () => window.open('https://green-award.ru' + CreateLinkTo.designer(id)),
        isLinks: true,
        element: GreenAwardIcon
      }
    },
  };

  galleryOrArtzServices.forEach((service: string) => {
    const key = service?.indexOf('gallllery') !== -1 ? 'gallery' : 'artz'

    result[key as any] = {
      action: () => handleMoveToLink(service),
      isLinks: true,
      element: key === 'gallery' ? GalllleryIcon : PrintArtzIcon
    }
  })

  return result
}

export interface LinksItems {
  action: () => void;
  isLinks: boolean;
  element: (() => ReactNode) | ReactNode
}

export const useServiceLinks = (id: string, designer?: Designer) => {

  const {
    isMediiia,
    isArtMediiia,
    isDeziiignMain,
    isGalllleryArt,
    isGreenAward,
    isFr,
    isKz,
  } = useAppTester();

  const designerRef = useRef<any>(null);
  const [serviceLinksList, setServiceLinksList] = useState<string[]>([]);
  const { data: channelsInfo } = useGetPersonalChannel(id, true);

  const channel = useMemo(() => {
    if (channelsInfo?.personalChannels?.length === 1) {
      return channelsInfo?.personalChannels?.[0]?.teamId;
    }
    else if (!!channelsInfo?.defaultChannel) {
      return channelsInfo?.defaultChannel;
    }
    else if (channelsInfo?.autoChannel) {
      return channelsInfo?.autoChannel?.teamId;
    }

    return null
  }, [channelsInfo])

  const roleLink = useMemo(() => {

    if (!isDeziiignMain) return null;

    const isEmployee =
      designerRef.current?.globalTypes?.includes("Employee") === true

    const isCooperator =
      designerRef.current?.globalTypes?.includes("Cooperator") === true

    const isStudent =
      designerRef.current?.globalTypes?.includes("Student") === true &&
      !isCooperator &&
      !isEmployee

    const isLPUEmployee =
      designerRef.current?.globalTypes?.includes("lpuemployee") === true

    const isIfCIDStudent =
      !!designerRef.current?.globalTypes?.includes("Hsecreativestudent")

    if (!!isLPUEmployee) {
      return {
        lpudesign: {
          action: () => window.open(process.env.REACT_APP_URL_HSECREATIVE + CreateLinkTo.designer(id)),
          isLinks: true,
          element: LpuIcon,
        }
      }
    }
    if (!!isIfCIDStudent) {
      return {
        irki: {
          action: () => window.open(process.env.REACT_APP_URL_HSE_SPACE + CreateLinkTo.designer(id)),
          isLinks: true,
          element: HseSpaceIcon,
        }
      }
    }
    if (isStudent || isEmployee || isCooperator) {
      return {
        hsedesign: {
          action: () => window.open(process.env.REACT_APP_URL_HSEDESIGN_RU + CreateLinkTo.designer(id)),
          isLinks: true,
          element: HseDesignLinkIcon,
        }
      }
    }

    return null;
  }, [designerRef.current, isDeziiignMain])

  useEffect(() => {
    if (id) {
      API.request()
        .endpoint(Endpoints.gateway)
        .url("/account/api/Account/GetActiveServices")
        .addQuery('accountId', id)
        .get()
        .send()
        .then((r) => r.json())
        .then((response) => {
          DesignerAPI.Get({ idDesigner: id })
            .then((r) => r.json())
            .then((responseSecond) => {
              designerRef.current = responseSecond
              return setServiceLinksList(response)
            })
        });
    }
  }, [id])

  const getActiveCardPath = (service: string) => {
    switch (service) {
      case 'gallllery.collection':
        return '/collection/'
      case 'gallllery.profile':
        return '/publicprofile/'
      case 'shop.collection':
        return '/collection/museum/'
      case 'shop.profile':
        return '/profile/museum/'
      default:
        return '/collection/'
    }
  }

  const handleMoveToLink = useCallback((service: string) => {
    const psfx = `shouldLogin=false`;

    const computeService = ['gallllery.collection', 'gallllery.profile']?.includes(service) ? 'gallery' :
      ['shop.profile', 'shop.collection']?.includes(service) ? 'artz' : service

    urlApi()?.getCollectionsByUser(id, computeService)
      .then((r) => {
        if (!r) return false;

        const domain = DOMAIN_NAMES[service as keyof TD]
        const route = getActiveCardPath(service)
        const userId = id
        const cardId = !r?.cardId ? '' : `card=${r?.cardId ?? 'empty'}&${psfx}`

        setTimeout(() => { window.open(domain + route + userId + cardId) })

      })

  }, [id])

  const hasArtMediiaProjects = useMemo(() => {
    return serviceLinksList?.includes('art.mediiia')
  }, [serviceLinksList])

  const galleryOrArtzServices = useMemo(() => {
    let result = [];

    if (serviceLinksList?.includes('gallllery.collection')) {
      result.push('gallllery.collection')
    }
    if (serviceLinksList?.includes('gallllery.profile')) {
      result.push('gallllery.profile')
    }
    if (serviceLinksList?.includes('shop.profile')) {
      result.push('shop.profile')
    }
    if (serviceLinksList?.includes('shop.collection')) {
      result.push('shop.collection')
    }

    return result
  }, [serviceLinksList])

  const links = useMemo(() => {
    if (isFr || isKz) {
      return {};
    }
    return {
      ...getServiceLinks({
        id,
        isDeziiignMain,
        isGalllleryArt,
        isGreenAward,
        isMediiia,
        handleMoveToLink,
        channel,
        hasArtMediiaProjects,
        galleryOrArtzServices,
        isArtMediiia
      }), ...roleLink
    }
  }, [handleMoveToLink, isDeziiignMain, isGalllleryArt, isMediiia, isGreenAward, roleLink, channel, galleryOrArtzServices, hasArtMediiaProjects, isArtMediiia])

  const filteredLinks = useMemo(() => {
    return Object.fromEntries(
      Object.entries(links)
        .filter(([key, value]) => {


          // @ts-ignore
          const renderedElement = typeof value.element === 'function' ? value.element() : null;
          const textFromElement = getTextFromElement(renderedElement);

          if (['artz', 'gallllery']?.includes(textFromElement) && !!galleryOrArtzServices?.length) {
            return true
          }

          return serviceLinksList?.includes(textFromElement) ||
            (serviceLinksList?.includes("greenaward") && textFromElement === "Зеленая премия") ||
            ROLES_LINK?.includes(textFromElement) || (!!channel && key === 'myMediiia')
        })
    );
  }, [links, serviceLinksList, channel, galleryOrArtzServices])

  return filteredLinks
}